import MarkUnreadChatAltOutlined from "@mui/icons-material/MarkUnreadChatAltOutlined";
import { Box, Skeleton, Typography } from "@mui/material";
import { usePermissions } from "../../../server/auth/use-permissions";
import { useInboxCount } from "../../layout/components/sidebar/hooks/use-inbox-count";

import type { FC } from "react";

/**
 * People with unread SMS replies, as the sidebar's Inbox badge shows. Only super admins can read
 * the count (and see the Inbox), so it is hidden for everyone else.
 */
export const UnreadInboxCount: FC = () => {
  const { super_admin } = usePermissions();
  const count = useInboxCount(super_admin);

  if (!super_admin) return null;

  return (
    <Box display="flex" alignItems="center" gap={0.5} title="Unread SMS conversations">
      <MarkUnreadChatAltOutlined fontSize="small" />
      {count !== null ? (
        <Typography variant="body2">{count} new</Typography>
      ) : (
        <Skeleton variant="text" width={40} />
      )}
    </Box>
  );
};
